import React, { Fragment, useCallback, useState } from 'react';
import Container from './DocumentTemplateContainer';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from '../../../../utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from '../../../../providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TEMPLATES } from 'constants/rightsCodes';

const Route = props => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const { getElemByAreaKey, bulkPrintingYN } = props;
  const documentTemplateId = props.match.params.documentTemplateId && getInt(props.match.params.documentTemplateId);

  const onClickClose = () => {
    historyContext.push(`/documentTemplates`);
  };

  const onChangeDocumentTemplateTitle = documentTemplateTitle => {
    setTitle(documentTemplateTitle);
  };

  const onRedirect = useCallback(
    documentTemplateId => {
      historyContext.push(`/documentTemplates/${documentTemplateId}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TEMPLATES}>
        <Container
          documentTemplateId={documentTemplateId}
          onChangeDocumentTemplateTitle={onChangeDocumentTemplateTitle}
          onRedirect={onRedirect}
          bulkPrintingYN={bulkPrintingYN}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired,
  bulkPrintingYN: PropTypes.bool
};

export default withAreaGetter(withRouter(Route));
